export default __webpack_public_path__ + "static/media/SupplyCampMap.dbfd20a7.jpg";